import type { IconSvgObject } from './types';

const TextItalicSlashIcon: IconSvgObject = [
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.4866 20.001H8.49328M5.5 20.001H8.49328M12.5 4H18.0017C18.6508 4 19.127 4.61122 18.9698 5.24231L18.781 6M12.5 4L11.5868 7.59996M12.5 4H8M8.49328 20.001L10.7075 11.1248", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TextItalicSlashIcon;
